module.exports = __webpack_public_path__ + "img/charm_tick.ec75d2c4.svg";